import { useQuery } from "@tanstack/react-query";
import * as globalServices from "../../services/GlobalServices";

export const useGetUserInfos = (enableFetchUser = false) => {
  const user = useQuery(['user-info'], () => globalServices.getUserInfos(), {
    enabled: enableFetchUser,
    retry: 0,
  });
  return user;
};


export const useGetUserByEmail = (enableFetchUser = false, email) => {
  const user = useQuery(['user-info-email', enableFetchUser], () => globalServices.getUserByEmail(email), {
    enabled: enableFetchUser
  });
  return user;
};

export const useGetVendedores = (enableFetch = false) => {
  const user = useQuery(['vendedores'], () => globalServices.getVendedores(), {
    enabled: enableFetch,
    retry: 0,
  });
  return user;
};
